import React from 'react'

export const StageContent = ({children}: {children: React.ReactNode}) => {
    return (
        <div className="flex max-w-5xl flex-1 flex-col items-center gap-2 self-center">
            {children}
        </div>
    )
}

export default StageContent
